import { render, staticRenderFns } from "./BankLoginForm.vue?vue&type=template&id=6b2f3631&scoped=true&"
import script from "./BankLoginForm.vue?vue&type=script&lang=js&"
export * from "./BankLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f3631",
  null
  
)

export default component.exports